<div class="calculation-row-container">
    <p>{{ 'aumico_notes_super_table_add_caclulation_select_calculation_type' | i18next }}</p>
    <div class="calculation-options">
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/sigma.svg"
            data-testid="calculation-function-summation"
            [ngClass]="{ selected: selectedOption === calculation.SUMMATION }"
            (buttonClick)="onSelectedCalculationFunctionChange(calculation.SUMMATION)"
        >
            {{ 'aumico_notes_super_table_add_calculation_function_summation' | i18next }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/chart-pie-outline.svg"
            data-testid="calculation-function-ratio"
            [ngClass]="{ selected: selectedOption === calculation.RATIO }"
            (buttonClick)="onSelectedCalculationFunctionChange(calculation.RATIO)"
        >
            {{ 'aumico_notes_super_table_add_calculation_function_ratio' | i18next }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/minus.svg"
            data-testid="calculation-function-subtraction"
            [ngClass]="{ selected: selectedOption === calculation.SUBTRACTION }"
            (buttonClick)="onSelectedCalculationFunctionChange(calculation.SUBTRACTION)"
        >
            {{ 'aumico_notes_super_table_add_calculation_function_subtraction' | i18next }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/x-outline.svg"
            data-testid="calculation-function-multiplication"
            [ngClass]="{ selected: selectedOption === calculation.MULTIPLICATION }"
            (buttonClick)="onSelectedCalculationFunctionChange(calculation.MULTIPLICATION)"
        >
            {{ 'aumico_notes_super_table_add_calculation_function_multiplication' | i18next }}
        </ham-button>
    </div>
</div>
